














import { PaymentRequisitionStatus } from '@/models';

import Vue from 'vue';
export default Vue.extend({
  name: 'PaymentRequisitionStatusDisplay',

  props: {
    status: { type: PaymentRequisitionStatus, required: true }
  }
});
